export function mergeArrays(arr1 = [], arr2  = []) {

    let a1 = JSON.parse(JSON.stringify(arr1));
    let a2 = JSON.parse(JSON.stringify(arr2));

    const merged = [];

    const map = new Map();

    // Helper function to merge objects
    function mergeObjects(obj1, obj2) {
        const obj = {
            ...obj1
        }
        if(obj.hasOwnProperty('PossibleValues') && Array.isArray(obj1.PossibleValues) && obj1.PossibleValues?.length) {
            const pv = obj.PossibleValues;
            const pv1 = JSON.stringify(obj1?.PossibleValues);

            obj2?.PossibleValues?.forEach((p) => {
                if(!pv1.includes(JSON.stringify(p))) pv.push(p)
            })

            obj.PossibleValues = pv
        } 
        if(obj.hasOwnProperty('Default')) obj.Default = [Math.min(...obj1.Default, ...obj2.Default), Math.max(...obj1.Default, ...obj2.Default)]
        
        if(obj1.hasOwnProperty('MaxValue') || obj2.hasOwnProperty('MinValue')) {
            obj.MaxValue = Math.max(obj1.MaxValue, obj2.MaxValue)
            obj.MinValue = Math.min(obj1.MinValue, obj2.MinValue)
        }

        return {
            ...obj
        };
    }

    // Process the first array
    a1.forEach(obj => {
        map.set(obj.Label, { ...obj });
    });
   
    // Process the second array
    a2.forEach(obj => {
        if (map.has(obj.Label)) {
            const existingObj = map.get(obj.Label);
            map.set(obj.Label, mergeObjects(existingObj, obj));
        } else {
            merged.push({...obj});
        }
    });
    
    // Convert map back to an array
    map.forEach(value => {
        merged.push(value);
    });

    arr1 = arr1.filter((arr) => arr.Label !== "Type")
    arr2 = arr2.filter((arr) => arr.Label !== "Type")

    return [merged, arr1, arr2];
}

export function mergeGallary(galleryComponent = {}, projectIds) {

        if (!galleryComponent || galleryComponent.TypeName !== "Gallery") {
          console.error("Invalid component data");
          return;
        }
     
        if (!Array.isArray(projectIds) || projectIds.length === 0) {
          console.error("Invalid projectIds array");
          return;
        }
      
        // Validate projectIds: all entries except index 0 must match the value at index 0
        const referenceId = projectIds[0];
  
        const isValid = projectIds.length > 1 ? projectIds.every((id, index) => {
          if(index) {
            if(referenceId.split(',').includes(id) || referenceId.includes(id)) return true
            return false
          }
          return true
        }): false
        if (!isValid) {
          return {
            0: galleryComponent, // Original unmodified object
            1: {},
            2: {},
          };
        }
      
        // Proceed with grouping photos
        const { ListOfPhotos } = galleryComponent.Data;
      
        // Initialize the result object with hardcoded keys
        const groupedPhotos = {
          0: galleryComponent, // Original unmodified object
          1: {
            TypeID: galleryComponent.TypeID,
            TypeName: galleryComponent.TypeName,
            Data: {
              NoOfPhotos: 0,
              ListOfPhotos: [],
            },
            Tags: []
          },
          2: {
            TypeID: galleryComponent.TypeID,
            TypeName: galleryComponent.TypeName,
            Data: {
              NoOfPhotos: 0,
              ListOfPhotos: [],
            },
            Tags: []
          },
        };
      
        // Map E_ID values to the hardcoded keys `1` and `2`
        const eIdToKeyMap = {};
        let currentKey = 1; // Start with key 1
      
        // Iterate over photos and distribute them into `1` and `2` keys
        ListOfPhotos.forEach((photo) => {
          const { E_ID } = photo;
          const tag = photo.Tags[0]
      
          // Map the E_ID to one of the hardcoded keys
          if (!eIdToKeyMap[E_ID]) {
            if (currentKey <= 2) {
              eIdToKeyMap[E_ID] = currentKey;
              currentKey++;
            } else {
              // Ignore E_IDs beyond the first two, or handle as needed
              // console.warn(`E_ID ${E_ID} ignored because only 2 keys (1, 2) are supported.`);
              return;
            }
          }
      
          // Add the photo to the appropriate hardcoded key
          const key = eIdToKeyMap[E_ID];
          groupedPhotos[key].Data.ListOfPhotos.push(photo);
          groupedPhotos[key].Data.NoOfPhotos++;
          
          if(!groupedPhotos[key].Tags.includes(tag)) groupedPhotos[key].Tags.push(tag)
        });
      
        return groupedPhotos;
}

export function filterInc(units = [], filter) {
  let newF = filter.map(option => ({ ...option }));

  const unitT = {
    rent: false,
    sales: false
  }

  for(let i=0; i<units.length; i++) {
    const unit = units[i]

    if(unit?.Data?.SalesTypeEjerlejlighed?.Value) {
      unitT.sales = true
    }else if(unit?.Data?.SalesTypeLejelejlighed?.Value) {
      unitT.rent = true
    }

    if(unitT.sales && unitT.rent) {
      newF.unshift({
        "Default": [
            101,
            103
        ],
        "Type": "MultiSelect",
        "Label": "Type",
        "Postfix": "",
        "PossibleValues": [
            {
                "ID": 101,
                "Value": "Salg",
                "ValueProperty": "SalesTypeEjerlejlighed"
            },
            {
                "ID": 103,
                "ValueProperty": "SalesTypeLejelejlighed",
                "Value": "Leje"
            }
        ]
      })
      break;
    };
  }

  if(unitT.sales && !unitT.rent) {
    const newD = getData(newF, "Status")

    if(Object.keys(newD).length) {
      newF[newD.index].PossibleValues = newF[newD.index]?.PossibleValues?.filter((pv) => {
        if(pv.ID === 30) return false
        return true
      })
    }
  }else if(!unitT.sales && unitT.rent) {
    const newD = getData(newF, "Status")

    if(Object.keys(newD).length) {
      newF[newD.index].PossibleValues = newF[newD.index]?.PossibleValues?.filter((pv) => {
        if(pv.ID === 40) return false
        return true
      })
    }
  }
  
  // console.log(unitT,newF,'unit')
  return newF
}

// get filter data by label
const getData = (array, label) => {
  
  for(let i=0; i<array.length; i++) {
    const obj = array[i]

    if(obj.Label === label) {
      return {
        index: i,
        data: obj
      }
      break;
    }
  }

  return {}
}